/* Collection-only presentation of existing server-resolved Product media. */
(function () {
  if (window.aorvoCollectionMediaContinuity) return;
  window.aorvoCollectionMediaContinuity = true;
  document.addEventListener('click', function (event) {
    var label = event.target.closest('[data-aorvo-collection-swatch]');
    var card = label && label.closest('[data-aorvo-collection-media-state]');
    if (!card) return;
    var id = label.getAttribute('data-aorvo-nav-variant');
    var payload;
    try { payload = JSON.parse(card.getAttribute('data-json-product')); } catch (_) { return; }
    if (!payload.variants.some(function (variant) { return String(variant.id) === id; })) return;
    var state = label.getAttribute('data-aorvo-media-state');
    var approved = state === 'MEDIA_APPROVED' && !!label.getAttribute('data-img');
    var region = card.querySelector('[data-aorvo-collection-media-region]');
    if (!region) return;
    var image = region.querySelector('[data-aorvo-collection-approved-image]');
    if (approved) {
      if (!image) {
        image = document.createElement('img');
        image.className = 'product__thumbnail';
        image.setAttribute('data-aorvo-collection-approved-image', '');
        image.loading = 'lazy';
        region.prepend(image);
      }
      image.setAttribute('src', label.getAttribute('data-img'));
      image.setAttribute('srcset', label.getAttribute('data-img'));
      image.setAttribute('data-src', label.getAttribute('data-img'));
      image.setAttribute('data-srcset', label.getAttribute('data-img'));
      image.alt = label.getAttribute('data-aorvo-image-alt') || '';
      image.width = Number(label.getAttribute('data-aorvo-image-width'));
      image.height = Number(label.getAttribute('data-aorvo-image-height'));
    } else if (image) image.remove();
    var pending = region.querySelector('[data-aorvo-collection-pending-copy]');
    pending.hidden = approved;
    pending.style.display = approved ? 'none' : 'flex';
    card.setAttribute('data-aorvo-collection-media-state', state);
    card.setAttribute('data-aorvo-navigation-variant-id', id);
    ['canonical-asset', 'source-sha256', 'media-gid'].forEach(function (key) {
      card.setAttribute('data-aorvo-' + key, approved ? label.getAttribute('data-aorvo-' + key) : '');
    });
    card.querySelectorAll('[data-aorvo-collection-link]').forEach(function (link) {
      var url = new URL(link.href, location.origin);
      url.searchParams.set('variant', id);
      link.href = url.href;
    });
  });
})();
